(function () {
  const fixBadge = (badge) => {
    const textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;
    const rating = parseFloat(badge.getAttribute('data-average-rating'));
    if (isNaN(rating)) return;
    textEl.textContent = rating.toFixed(1);
  };

  const fixAllBadges = () => {
    document.querySelectorAll('.jdgm-prev-badge').forEach(fixBadge);
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'childList') {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.classList?.contains('jdgm-prev-badge')) {
            fixBadge(node);
          } else {
            node.querySelectorAll?.('.jdgm-prev-badge').forEach(fixBadge);
          }
        });
      }
      if (m.type === 'attributes' && m.target instanceof Element && m.target.classList.contains('jdgm-prev-badge')) {
        fixBadge(m.target);
      }
    }
  });

  const init = () => {
    fixAllBadges();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
